





































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Contatto } from '@/data/models/contatto.model';

@Component
export default class CallCenterContatto extends Vue {
	@Prop() contatto!: Contatto;
}
